// extracted by mini-css-extract-plugin
export var isPrintedCell = "_wz-1";
export var printerIcon = "_wz-0";